const PROJECT_LANGUAGE = 'en';

export function initialize(applicationInstance) {
  const intl = applicationInstance.lookup('service:intl');

  // TODO: Replace with a new dashboard helper or service
  const currentLanguage = window.navigator.language;
  // Copied from app/instance-initializers
  const currentLanguageNoRegion = currentLanguage.replace(/[_-].+$/, '');
  const locales = [PROJECT_LANGUAGE];
  if (
    currentLanguageNoRegion !== currentLanguage &&
    !locales.includes(currentLanguageNoRegion)
  ) {
    locales.unshift(currentLanguageNoRegion);
  }
  if (!locales.includes(currentLanguage)) {
    locales.unshift(currentLanguage);
  }

  intl.setLocale(locales);
}

export default {
  initialize,
};
